import { DatePipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslocoPipe } from '@jsverse/transloco';
import { TimeTrackingBarService } from './time-tracking-bar.service';

@Component({
    selector: 'app-time-tracking-detail-sheet',
    standalone: true,
    imports: [TranslocoPipe, DatePipe, NgClass, MatIconModule, MatButtonModule, MatDividerModule, MatListModule],
    templateUrl: './time-tracking-detail-sheet.component.html',
    styleUrl: './time-tracking-detail-sheet.component.scss',
})
export class TimeTrackingDetailSheetComponent {
    now = new Date();
    constructor(
        public time: TimeTrackingBarService,
        private ref: MatDialogRef<TimeTrackingDetailSheetComponent>
    ) {}
    close(): void {
        this.ref.close();
    }
}
